// Vendors
import { TrackingEventsEnum, TrackingLinkEventReturnType } from '@openbank/ziniaweb-ui-core-models';
// Types
import { TrackBuilderType } from 'types/track-builder.type';
import { PaymentErrorTrackingHandlersType } from './types/payment-error.tracking.handlers.type';

const trackPaymentTryAgainHandler = (): TrackingLinkEventReturnType => ({
  payload: {
    action: 'click',
    format: 'button',
    component: 'emptyStates',
    element: 'tryAgain',
    eventCategory: 'validateThePayment',
    eventAction: 'clickButton',
    eventLabel: 'tryAgainButton',
  },
  type: TrackingEventsEnum.LINK,
});

const PaymentErrorTrackingHandlers = (
  track: TrackBuilderType
): PaymentErrorTrackingHandlersType => ({
  handleTrackPaymentErrorTryAgain: () => track(trackPaymentTryAgainHandler()),
});

export { PaymentErrorTrackingHandlers };
